import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { injectIntl } from "react-intl";

function PostFeedSummary({ intl }) {
  const [questions, setQuestions] = useState(null);
  const [answers, setAnswers] = useState(null);
  const [comment, setComment] = useState("");
  const history = useHistory();

  useEffect(() => {
    const savedQuestions = localStorage.getItem("question");
    const savedAnswers = localStorage.getItem("answer");
    const savedComment = localStorage.getItem("comment");

    if (savedQuestions && savedAnswers) {
      setQuestions(JSON.parse(savedQuestions));
      setAnswers(JSON.parse(savedAnswers));

      if (savedComment && savedComment !== "undefined" && savedComment !== "null") {
        setComment(savedComment);
      } else {
        setComment("");
      }
    } else {
      history.replace("/testing/detail");
    }
  }, [history]);

  const handleConfirm = () => {
    history.push("/");
  };

  const getReadableAnswer = (question, answerValue) => {
    const { question_type, valid_answer } = question;

    if (question_type === "radio") {
      const index = parseInt(answerValue) - 1;
      return valid_answer?.[index] ?? answerValue;
    }

    if (question_type === "scale") {
      return answerValue;
    }

    if (question_type === "checkbox") {
      let indices = [];

      if (Array.isArray(answerValue)) {
        indices = answerValue.map((val) => parseInt(val) - 1);
      } else if (typeof answerValue === "string") {
        indices = answerValue.split(",").map((val) => parseInt(val.trim()) - 1);
      }

      return indices.map((idx) => valid_answer?.[idx]).filter(Boolean).join(", ");
    }

    return answerValue;
  };

  return (
    <div className="inner-page">
      <h3 className="test-box-title">
        {intl.formatMessage({ id: "TESTING.GENERAL.REVIEW" })}
      </h3>

      {questions && answers ? (
        questions.map((question, index) => (
          <div key={question.question_id} className="finish-box">
            <div className="response-text">
              <h4>{index + 1}.{question.question}</h4>
              <p>
                <strong>{intl.formatMessage({ id: "TESTING.GENERAL.RESPONSE" })}:</strong>{" "}
                {getReadableAnswer(question, answers[question.question_id])}
              </p>
            </div>
          </div>
        ))
      ) : (
        <p>{intl.formatMessage({ id: "TESTING.GENERAL.NO_ANSWERS" })}</p>
      )}

      <div className="finish-box">
      <div className="response-text">
        <h4>{intl.formatMessage({ id: "TESTING.GENERAL.COMMENTS_OPTIONAL" })}</h4>
        <p>{comment && comment.trim() !== "" ? comment : "-"}</p> 
      </div>
      </div>

      <button className="btn btn-primary" onClick={handleConfirm}>
        {intl.formatMessage({ id: "TESTING.BUTTON.CONFIRM" })}
      </button>
    </div>
  );
}

export default injectIntl(PostFeedSummary);
